<template>
  <div class="fRow fullWidth jStart aCenter accItem wrap">
    <div class="indx">1</div>
    <div class="fCol jCenter aStart growFull">
      <div class="accName fRow jStart aCenter">{{data.name}}
        <div class="bankName">بانک {{data.bank}}</div>
      </div>
      <div class="accNumber" style="margin-bottom: 16px">
        شمارۀ حساب: <div class="bold">{{data.number}}</div></div>
      <div class="accNumber"
        v-if="data.card !== null || data.card !== ''">
        شمارۀ کارت: <div class="bold">{{data.card}}</div></div>
      <div class="accNumber"
        v-if="data.card === null || data.card === ''">شمارۀ کارت تعریف نشده</div>
    </div>
    <div class="status fRow jCenter aCenter">
      <switch-button
        :val="status"
        @click.native="invertState"
        activeLabel='فعال'
        deactiveLabel='غیرفعال'/>
    </div>
    <div class="b fab fCol jCenter aCenter" @click="deleteMode = true">
      <i class="material-icons-round">delete</i>
    </div>
    <div class="b fab fCol jCenter aCenter" @click="goEdit">
      <i class="material-icons-round">edit</i>
    </div>
    <div class="fullWidth fCol jCenter aStart desc">
      <span class="accDescTitle">توضیحات</span>
      <p class="accDesc">{{data.description}}</p>
    </div>
    <div class="deleteBox fRow jStart aCenter wrap"
      v-if="deleteMode">
      <div class="q fullWidth">آیا از حذف {{data.name}} مطمئن هستید؟</div>
      <div class="tip fullWidth">این عملیات برگشت ناپذیر است</div>
      <div class="yes fRow jStart aCenter" @click="deleteAccount">
        <i class="material-icons-round">delete</i>
        <label>بله، حذف شود</label>
      </div>
      <div class="no fRow jStart aCenter" @click="deleteMode = false">
        <i class="material-icons-round">keyboard_arrow_left</i>
        <label>بازگشت</label>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SwitchButton from '@/components/SwitchButton.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';

export default {
  props: ['data'],
  mixins: [errorHandler, makeToast],
  components: {
    SwitchButton,
  },
  data() {
    return {
      status: true,
      deleteMode: false,
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
    };
  },
  methods: {
    invertState() {
      axios({
        method: 'patch',
        url: `${this.baseURL}/api/v${this.V}/Financials/account/${this.data.id}?status=${!this.status}`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.whileState = false;
        if (response.data.isSuccess) {
          this.status = !this.status;
          if (this.gradeStatus) {
            this.makeToast('success', 'مجوز مورد نظر فعال شد', 2000);
          } else {
            this.makeToast('success', 'مجوز مورد نظر غیرفعال شد', 2000);
          }
        }
      }, (error) => {
        this.whileState = false;
        this.makeToast('error', this.errorHandler(error), 2000);
      });
    },
    deleteAccount() {
      axios({
        method: 'delete',
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        url: `${this.baseURL}/api/v${this.V}/Financials/account/${this.data.id}`,
      }).then((response) => {
        // console.log('delete', response);
        if (response.data.isSuccess) {
          this.makeToast('success', 'حساب مورد نظر با موفقیت حذف شد', 2000);
          this.$emit('refresh');
        } else {
          this.$store.commit('closeCard');
          this.makeToast('error',
            'برای این حساب اطلاعات ثبت شده است امکان حذف وجود ندارد', 5000);
        }
      }, (error) => {
        // console.log(error);
        this.makeToast('error', this.errorHandler(error), 2000);
      });
    },
    goEdit() {
      this.$emit('editAccount', this.data);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.status = this.data.status;
    });
  },
};
</script>

<style lang="scss" scoped>
.accItem {
  padding: 8px;
  border-radius: 16px;
  margin-top: 8px;
  position: relative;
  overflow: hidden;
  border: solid 2px rgba($color: #000000, $alpha: 0.15);
  box-shadow: 0 8px 12px -12px rgba($color: #000000, $alpha: 0.25);
  // border: solid 1px rgba($color: #000000, $alpha: 0.15);
  .indx {
    width: 24px;
    text-align: center;
    font-size: 10px;
    margin-left: 8px;
    display: none;
  }
  .accName {
    font-size: 18px;
    font-weight: 300;
    margin-bottom: 8px;
    background-color: rgba($color: #000000, $alpha: 0.05);
    padding: 0px 8px 0px 4px;
    border-radius: 16px;
    .bankName {
      display: inline;
      padding: 2px 8px;
      border-radius: 16px;
      background-color: rgba($color: #33d16d, $alpha: 0.85);
      color: white;
      margin-right: 16px;
      font-size: 10px;
    }
  }
  .accNumber {
    font-size: 10px;
    text-align: right;
    padding-right: 8px;
    .bold {
      font-weight: bold;
      letter-spacing: 2px;
      font-size: 14px;
    }
  }
  .status {
    width: 112px;
  }
  .desc {
    padding: 8px;
    border-radius: 8px;
    margin-top: 8px;
    background-color: rgba($color: #000000, $alpha: 0.05);
    .accDescTitle {
      font-size: 10px;
      padding: 0;
      margin: 0;
      color: rgba($color: #8a8a8a, $alpha: 1.0);
    }
    .accDesc {
      font-size: 12px;
      padding: 0;
      margin: 0;
    }
  }
  .deleteBox {
    z-index: 100;
    position: absolute;
    padding: 16px;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    align-content: flex-start;
    background-color: rgb(177, 26, 26);
    .q {
      font-size: 16px;
      color: white;
      text-align: right;
      font-weight: bold;
    }
    .tip {
      font-size: 12px;
      color: rgb(228, 146, 146);
      text-align: right;
      font-weight: 300;
      margin-bottom: 8px;
    }
    .yes {
      background-color: white;
      border-radius: 16px;
      padding: 2px 8px;
      cursor: pointer;
      * {
        pointer-events: none;
      }
      i {
        font-size: 16px;
        margin-left: 4px;
        color: red;
      }
      label {
        font-weight: bold;
        font-size: 12px;
        color: red;
      }
    }
    .no {
      border-radius: 16px;
      padding: 2px 8px;
      cursor: pointer;
      background-color: rgba($color: #000000, $alpha: 0.15);
      margin-right: 8px;
      * {
        pointer-events: none;
      }
      i {
        font-size: 12px;
        margin-left: 4px;
        color: rgb(255, 255, 255);
      }
      label {
        font-weight: bold;
        font-size: 12px;
        color: rgb(255, 255, 255);
      }
    }
  }
}
</style>
